import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { makeApi } from "@/lib/api";
import { clearDriverToken, getDriverToken } from "@/lib/driverAuth";

const Ctx = createContext(null);
export const useDriverMe = () => useContext(Ctx);

const Notice = ({ title, text, onOut }) => (
  <div className="min-h-screen grid place-items-center p-6 bg-slate-50" data-testid="driver-gate-notice">
    <div className="max-w-sm text-center rounded-2xl border border-slate-200 bg-white p-8">
      <h1 className="text-xl font-bold" style={{ fontFamily: "Outfit" }}>{title}</h1>
      <p className="mt-2 text-sm text-slate-600">{text}</p>
      <Button onClick={onOut} className="mt-6 bg-[#002FA7] hover:bg-[#001A75]" data-testid="driver-gate-sign-out-btn">Sign out</Button>
    </div>
  </div>
);

// Guards /driver/* with the admin-created driver login (not Clerk).
export default function DriverGate({ children }) {
  const navigate = useNavigate();
  const [state, setState] = useState(getDriverToken() ? { loading: true } : { out: true });

  useEffect(() => {
    if (!getDriverToken()) return;
    makeApi(() => null).get("/me")
      .then(({ data }) => setState({ me: data }))
      .catch((e) => {
        if (e?.response?.status === 401) { clearDriverToken(); setState({ out: true }); }
        else setState({ error: e?.response?.data?.detail || "Could not reach Fleet Sheet. Check your signal." });
      });
  }, []);

  const signOut = () => { clearDriverToken(); navigate("/driver-login", { replace: true }); };
  if (state.out) return <Navigate to="/driver-login" replace />;
  if (state.loading) return <div className="min-h-screen grid place-items-center text-slate-500" data-testid="driver-gate-loading">Loading…</div>;
  if (state.error) return <Notice title="Can't open your loads" text={state.error} onOut={signOut} />;
  const { me } = state;
  if (me.archived) return <Notice title="Account archived" text="Your driver account is no longer active. Contact your dispatcher if this is a mistake." onOut={signOut} />;
  if (me.workspace_status !== "active") return <Notice title="Carrier account deactivated" text="This carrier's account is currently deactivated." onOut={signOut} />;
  return <Ctx.Provider value={{ ...me, signOut }}>{children}</Ctx.Provider>;
}
